import { FC } from 'react';

import { IEmptyProps } from 'types/components/table';

const Empty: FC<IEmptyProps> = ({ columnSpan, message }) => {
  return (
    <tr>
      <td colSpan={columnSpan}>
        <div className="align-items-center d-flex flex-grow-1 justify-content-center text-muted">{message}</div>
      </td>
    </tr>
  );
};

export default Empty;
